export default "__VITE_ASSET__CF6KXKXj__"